import { Box, Container, InputBase, MenuItem } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const BrandImage = styled("img")({
  marginRight: "1rem",
});

export const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.primary.light,
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.05),
  },
  display: "none",
  [theme.breakpoints.up("sm")]: {
    display: "flex",
  },
}));

export const StyledDesktopSearch = styled(Search)(({ theme }) => ({
  marginRight: theme.spacing(2),
  display: "none",
  [theme.breakpoints.up("sm")]: {
    display: "flex",
    width: "45ch",
  },
}));

export const StyledMobileSearch = styled(Search)(({ theme }) => ({
  display: "flex",
  alignSelf: "center",
  margin: "1rem",
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));

export const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

export const StyledCategoriesContainer = styled(Container)`
  display: flex;
  justify-content: center;
  overflow-x: auto;
  padding: 1rem 0rem 0rem 1rem;
  &&::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  && {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`;
export const StyledCategoryImage = styled("div")`
  width: 65px;
  height: 65px;
  border-radius: 32.5px;
  margin-top: 3.3rem;
  margin-bottom: 0.5rem;
  position: relative;
`;

export const StyledMobileSidebarTopBox = styled(Box)(
  ({ theme }) => `
  background-color: ${theme.palette.neutral.main};
  padding:1.5rem;
`
);

export const SearchBoxDropDown = styled(Box)(({ theme }) => ({
  position: "absolute",
  background: "#fff",
  width: "45ch",
  display: "block",
  // boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const SearchBoxDropDownInMobile = styled(Box)(({ theme }) => ({
  position: "absolute",
  background: "#fff",
  width: "92%",
  display: "block",
  margin: "0px 1rem",
  // boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
}));
